module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av272-5170029b602e7cc35adabd4c2777cb9a.jpg";